<template>
  <box-generic
    class="w-full h-full"
    :hStretch="true"
    :wStretch="true"
    :header="routedVideo.title"
    :header-class="computedHeaderClass"
  >
    <transition-fade :duration="500" appear>
      <div
        v-if="routedVideo?.videoFile?._rendered"
        id="video-player"
        class="flex flex-col items-start h-full justify-stretch p-[15px]"
      >
        <div
          class="grid items-stretch justify-items-stretch self-stretch grow"
          v-html="routedVideo.videoFile._rendered"
        />
      </div>
    </transition-fade>
  </box-generic>
  <MediaFilmCircle
    class="pointer-events-none absolute top-0 right-0 translate-x-[-20%] translate-y-[20%]"
    :color="
      activeSeasonContentForSchoolLevel.schoolLevel.slug === 'onderbouw'
        ? '#127b5d'
        : '#6c44a5'
    "
  />
</template>

<script>
import { mapGetters } from "vuex";

import BoxGeneric from "../../../components/content/BoxGeneric.vue";
import TransitionFade from "../../../components/magic/TransitionFade.vue";
import MediaFilmCircle from "../../../components/content/svg/MediaFilmCircle.vue";

export default {
  name: "VideoPlayer",
  components: {
    TransitionFade,
    BoxGeneric,
    MediaFilmCircle,
  },
  computed: {
    ...mapGetters(["activeSeasonContentForSchoolLevel", "routedVideo"]),
    computedHeaderClass() {
      const slug = this.activeSeasonContentForSchoolLevel?.schoolLevel?.slug;
      return slug ? `title-block title-block-${slug}` : "title-block";
    },
  },
};
</script>
